import { memo } from '../../lib/teact/teact';

import type { ApiChatMember } from '../../api/types';
import type { ObserveFn } from '../../hooks/useIntersectionObserver';
import type { MenuItemContextAction } from '../ui/ListItem';

import buildClassName from '../../util/buildClassName';

import useLastCallback from '../../hooks/useLastCallback';

import PrivateChatInfo from '../common/PrivateChatInfo';
import ListItem from '../ui/ListItem';

import styles from './Profile.module.scss';

type OwnProps = {
  userId: string;
  chatId: string;
  chatMember?: ApiChatMember;
  contextActions?: MenuItemContextAction[];
  observeIntersection: ObserveFn;
  onClick: (userId: string) => void;
};

// A row of its own, so a status update re-renders only the member it is about, not every row of a big group
const ProfileMember = ({
  userId,
  chatId,
  chatMember,
  contextActions,
  observeIntersection,
  onClick,
}: OwnProps) => {
  const handleClick = useLastCallback(() => {
    onClick(userId);
  });

  return (
    <ListItem
      className={buildClassName(
        styles.memberItem, 'chat-item-clickable contact-list-item scroll-item small-icon',
      )}
      onClick={handleClick}
      contextActions={contextActions}
      withPortalForMenu
    >
      <PrivateChatInfo
        userId={userId}
        chatMemberOriginId={chatId}
        chatMember={chatMember}
        forceShowSelf
        withStory
        observeIntersection={observeIntersection}
      />
    </ListItem>
  );
};

export default memo(ProfileMember);
